import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import { Link } from "react-router-dom";
import TextField from "@mui/material/TextField";
import checkImg from "../../assets/images/check_circle.svg";
import errorSign from "../../assets/images/errorSign.svg";
import { sendForgotPasswordEmail } from "../../Actions/LoginPageAction";
import "./style.scss";
import { useDispatch, useSelector } from "react-redux";

const ForgotPassword = () => {
  const [formData, setFormData] = useState({ email: "" });
  const [formError, setFormError] = useState("");
  const [showError, setShowError] = useState(false);
  const { forgotPasswordSuccess, forgotPasswordError } = useSelector(
    (state) => state.login
  );
  const dispatch = useDispatch();
  const [successMessage, setSuccessMessage] = useState(false);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  useEffect(() => {
    if (forgotPasswordSuccess) {
      setSuccessMessage(true);
      setFormData({ email: "" });
      setShowError(false);
      setFormError("");
      setTimeout(() => {
        document.getElementById("emailSentBacksignbutton").focus();
      }, 200);
    } else if (forgotPasswordError) {
      setFormError(forgotPasswordError?.response?.data?.message);
      setShowError(true);
      setSuccessMessage(false);
      dispatch({ type: 'FORGOT_PASSWORD_RESET' });
    }
  }, [forgotPasswordSuccess, forgotPasswordError]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.email === "") {
      setShowError(true);
      setFormError("Please enter the email.");
      return;
    }
    dispatch(sendForgotPasswordEmail(formData.email));
  };

  useEffect(() => {
    return () => {
      setSuccessMessage(false);
      dispatch({ type: 'FORGOT_PASSWORD_RESET' });
    }
  }, [])
  const clearStateonbacksign = () => {
    setSuccessMessage(false);
  };
  useEffect(() => {
    if (showError) {
      setTimeout(() => {
        setShowError(false);
        setFormError("");
      }, 5000);
    }
  }, [showError]);
  useEffect(() => {
    setTimeout(() => {
      document.getElementById("email").focus();
    }, 200);
  }, []);

  return (
    <>
      {showError && (
        <div className="error_wraper" role="alert" aria-live="assertive">
          <img src={errorSign} alt="" />
          {formError}
        </div>
      )}
      <div className="right-section forgotsection">
        {!successMessage ? (
          <div
            className="login-form forgotError"
            
          >
            <h1 id="forgot-password-heading">Forgot your password</h1>
           
            <form
              className="field"
              onSubmit={handleSubmit}
              aria-labelledby="forgot-password-heading"
            >
              <div role="group"  aria-labelledby="forgotLenged">
                 <p className="paragraphForgot" id="forgotLenged">
                  Please enter the email entered while creating the account, and
                  we’ll send you a link to reset the password.
                </p>
                <Box noValidate autoComplete="off" className="field">
                  <TextField
                    id="email"
                    name="email"
                    label="Email"
                    data-testid="email-textfield"
                    variant="outlined"
                    onChange={handleInputChange}
                    value={formData.email}
                    error={!!formError?.emailError}
                    helperText={formError?.emailError}
                    sx={{
                      "& .MuiInputLabel-root": { transform: "inherit" }, // Replaces InputLabelProps
                    }}
                    aria-required="true"
                    aria-invalid={!!formError?.emailError}
                    aria-describedby={
                      formError?.emailError ? "email-error-text" : undefined
                    }
                    required
                  />
                </Box>
                <button
                  type="submit"
                  className="btnSubmit"
                  data-testid="send-resent-link-email"
                  aria-label="Send reset link to email"
                >
                  Send reset link to email
                </button>
                <Link
                  to="/"
                  state={{ focusLoginButton: true }}
                  className="forgot-password"
                  aria-label="Back to sign in page"
                  onClick={clearStateonbacksign}
                >
                  Back to Sign in
                </Link>
              </div>
              {/* <a href="/" rel="noopener noreferrer" className="forgot-password">Back to Sign in</a> */}
            </form>
          </div>
        ) : (
          <div role="status" aria-live="polite">
            <div className="emailsent-wrapper">
              <img src={checkImg} alt="" />
              <h1 id="email-sent-heading">Email Sent.</h1>
              <p id="email-sent-description">
                Check your email for a link to reset your password.
              </p>
            </div>
            <Link
              to="/"
              className="forgot-password"
              state={{ focusLoginButton: true }}
              aria-describedby="email-sent-heading email-sent-description"
              aria-label="Back to sign in page"
              id="emailSentBacksignbutton"
              onClick={clearStateonbacksign}
            >
              Back to Sign in
            </Link>
          </div>
        )}
      </div>
    </>
  );
};

export default ForgotPassword;
